import {Button, Dropdown, Empty, Skeleton} from "antd";
import type {MenuProps} from "antd";
import {DeleteOutlined, EditOutlined, MoreOutlined, RightOutlined, TeamOutlined} from "@ant-design/icons";
import React, {FC} from "react";
import {AdministrationListProps, EmployeeItem} from "../../../../types/employee";
import "./style.less"
import {getImageLink} from "../../../../helpers/mainHelpers";
import * as BUCKETS from "../../../../enums/buckets";
import {useAuth} from "../../../../context/authContext";

const AdministrationList: FC<AdministrationListProps> = ({employeeController}) => {
  const {showDetailButtonHandler, employeeList, isLoading} = employeeController
  const {canManageContent} = useAuth()

  const getAdminMenu = (employee: EmployeeItem): MenuProps["items"] => [
    {
      key: "edit",
      icon: <EditOutlined/>,
      label: "Редагувати",
      onClick: () => employeeController.editButtonHandler(employee),
    },
    {
      key: "delete",
      danger: true,
      icon: <DeleteOutlined/>,
      label: "Видалити",
      onClick: () => employeeController.confirmDeleteEmployee({
        id: employee.$id || "",
        name: employee.fullName,
      }),
    },
  ]

  return <section className="administration-section" aria-labelledby="administration-heading">
    <header className="administration-section__intro">
      <div className="administration-section__icon" aria-hidden="true"><TeamOutlined/></div>
      <div>
        <div className="administration-section__eyebrow">Керівництво лікарні</div>
        <h1 className="administration-section__title" id="administration-heading">Наша адміністрація</h1>
        <p className="administration-section__description">
          Команда, яка відповідає за розвиток закладу та якість медичної допомоги.
        </p>
      </div>
    </header>

    {isLoading && employeeList.length === 0
      ? <div className="administration-grid administration-grid--loading" aria-label="Завантаження адміністрації">
        {[0, 1, 2].map((item) => <div className="administration-skeleton" key={item}>
          <Skeleton.Image active/>
          <Skeleton active paragraph={{rows: 2}} title={{width: "70%"}}/>
        </div>)}
      </div>
      : employeeList.length === 0
        ? <div className="administration-section__empty"><Empty description="Інформацію про адміністрацію ще не додано"/></div>
        : <div className={`administration-grid ${isLoading ? "administration-grid--updating" : ""}`}>
          {employeeList.map((employee) => <article className="administration-card" key={employee.$id || employee.fullName}>
            <button
              className="administration-card__main"
              type="button"
              onClick={() => showDetailButtonHandler(employee)}
              aria-label={`Докладніше про ${employee.fullName}`}
            >
              <div className="administration-card__portrait">
                {employee.image
                  ? <img
                    className="administration-card__image"
                    src={getImageLink({imageId: employee.image, bucketId: BUCKETS.MAIN})}
                    alt={`Фото: ${employee.fullName}`}
                    loading="lazy"
                  />
                  : <div className="administration-card__placeholder" aria-hidden="true">
                    {employee.fullName?.trim().charAt(0) || "А"}
                  </div>}
                <div className="administration-card__portrait-overlay"/>
              </div>

              <div className="administration-card__content">
                <h2 className="administration-card__name">{employee.fullName}</h2>
                <p className="administration-card__position">{employee.position}</p>
                <span className="administration-card__more">Детальна інформація <RightOutlined/></span>
              </div>
            </button>

            {canManageContent && <Dropdown menu={{items: getAdminMenu(employee)}} trigger={["click"]}>
              <Button
                className="administration-card__admin"
                type="text"
                shape="circle"
                icon={<MoreOutlined/>}
                aria-label={`Керування записом: ${employee.fullName}`}
              />
            </Dropdown>}
          </article>)}
        </div>}
  </section>
}

export default AdministrationList
